export default () => {
    return {
        chart: {
            zooming: {
                type: null,
            },
        },
    };
};
